import { Provider } from 'react-redux';
import persistStore from 'redux-persist/es/persistStore';
import { PersistGate } from 'redux-persist/integration/react';
import './App.css';
import ProjectRoutes from './routes/ProjectRoutes';
import store from './Utils/Redux/store';
import { useAppConfiguration } from './Utils/hooks/useAppConfiguration';

let persistor = persistStore(store);

// Wrapper component to initialize configuration
function AppWithConfiguration() {
  useAppConfiguration(); // Initialize configuration on app load
  return <ProjectRoutes />;
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppWithConfiguration />
      </PersistGate>
    </Provider>
  );
}

export default App;
